import { useEffect } from "react";
import { useLoaderData } from "react-router";

import { CalloutBanner } from "../components/CalloutBanner";
import { HomeCallout } from "../components/HomeCallout";
import { HomeProducts } from "../components/HomeProducts";
import { HomeUpsell } from "../components/HomeUpsell";
import { PageSeo } from "../components/PageSeo";
import Config from "../Config";
import { useCategoriesStore } from "../stores/CategoriesStore";
import { useHotelStore } from "../stores/HotelStore";

export const Home = () => {
	const loaderData = useLoaderData() || {};
	const initialHomepage = loaderData.homepageInfo ?? [];
	const initialMeta = loaderData.meta ?? null;
	const prefetchedProducts = loaderData.prefetchedProducts ?? [];

	const { homepageInfo } = useCategoriesStore((state) => ({ homepageInfo: state.homepageInfo }));
	const { setHotelFlow } = useHotelStore((state) => ({
		setHotelFlow: state.setHotelFlow,
	}));

	useEffect(() => {
		setHotelFlow(false);
	}, [setHotelFlow]);

	useEffect(() => {
		if (!initialHomepage?.length) return;
		if (homepageInfo?.length) return;
		useCategoriesStore.setState({ homepageInfo: initialHomepage });
	}, [homepageInfo?.length, initialHomepage?.length]);

	return (
		<>
			<PageSeo
				title={initialMeta?.title ?? Config.meta.title}
				description={initialMeta?.description ?? Config.meta.description}
				keywords={initialMeta?.keywords ?? ""}
				canonical={initialMeta?.canonical ?? ""}
				h1={initialMeta?.h1 ?? ""}
				h2={initialMeta?.h2 ?? ""}
				footerContent={initialMeta?.footerContent ?? ""}
				structuredData={initialMeta?.structuredData ?? {}}
			/>
			<div className="home">
				<HomeUpsell />
				<CalloutBanner />
				<HomeProducts initialHomepage={initialHomepage} prefetchedProducts={prefetchedProducts} />
				<HomeCallout />
			</div>
		</>
	);
};

export default Home;
